<ng-template #components>
  <ng-content></ng-content>
</ng-template>

<ng-template #primaryMenu>
  <ng-content select="[primaryMenu]"></ng-content>
</ng-template>

<ng-template #footerNav>
  <ng-content select="[fuseVerticalNavigationFooter]"></ng-content>
</ng-template>

<!-- ----------------------------------------------------------------------------------------------------- -->
<!-- Empty layout -->
<!-- ----------------------------------------------------------------------------------------------------- -->
<empty-layout *ngIf="layout === 'empty'"></empty-layout>

<!-- Compact -->
<compact-layout
  *ngIf="layout === 'compact'"
  [enableGlobalSearch]="enableGlobalSearch"
  [fullscreenTooltip]="fullscreenTooltip"
  (logoClick)="logoClick.emit()"
>
  <ng-container primaryMenu *ngTemplateOutlet="primaryMenu"></ng-container>
  <ng-container *ngTemplateOutlet="components"></ng-container>
  <ng-container fuseVerticalNavigationFooter *ngTemplateOutlet="footerNav"></ng-container>
</compact-layout>

<!-- Dense -->
<dense-layout *ngIf="layout === 'dense'">
  <ng-container *ngTemplateOutlet="components"></ng-container>
</dense-layout>

<!-- Futuristic -->
<futuristic-layout *ngIf="layout === 'futuristic'">
  <ng-container *ngTemplateOutlet="components"></ng-container>
</futuristic-layout>

<!-- Thin -->
<thin-layout *ngIf="layout === 'thin'">
  <ng-container *ngTemplateOutlet="components"></ng-container>
</thin-layout>
